import JSZip from 'jszip';
import { saveAs } from 'file-saver';

import { useLazyDownloadSlideAnnotationsQuery } from 'store/apis/slidesApi';
import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';

export const useDownloadAnnotations = ({ modelId, slides }) => {
  const [downloadSlideML, { isFetching, error }] =
    useLazyDownloadSlideAnnotationsQuery();

  useQueryError(error);

  const downloadAnnotations = async () => {
    const promises = slides.map(async (slide) => {
      const mlData = await downloadSlideML({
        slideUUID: slide.uuid,
        modelId,
      }).unwrap();
      const jsonString = JSON.stringify(mlData, null, 2);

      return {
        slideName: slide.name,
        data: jsonString,
      };
    });

    const annotationsData = await Promise.all(promises);

    if (annotationsData.length > 1) {
      const folderName = `${slides.length}slides-annotations`;
      const zip = new JSZip();
      const folder = zip.folder(folderName);

      annotationsData.forEach(({ slideName, data }) =>
        folder.file(`${slideName}-annotations.txt`, data),
      );

      const content = await zip.generateAsync({ type: 'blob' });

      saveAs(content, `${folderName}.zip`);
    } else {
      const { slideName, data } = annotationsData[0];
      const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });

      saveAs(blob, `${slideName}-annotations.txt`);
    }
  };

  return { isFetching, downloadAnnotations };
};
